import { TabPanels, TabPanelsProps } from "@chakra-ui/react";

export interface FilterTabPanelsProps extends TabPanelsProps {}

export const FilterTabPanels = (props: FilterTabPanelsProps) => {
  return <TabPanels p={0} {...props} />;
};
